import { render, staticRenderFns } from "./LogoCsaMed.vue?vue&type=template&id=48654f0f&scoped=true"
import script from "./LogoCsaMed.vue?vue&type=script&lang=js"
export * from "./LogoCsaMed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2cae27f83758b46b73a9745eca16177c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48654f0f",
  null
  
)

export default component.exports